import { render, staticRenderFns } from "./PopularizeDubaHuyan.vue?vue&type=template&id=647dfd79&scoped=true&"
import script from "./PopularizeDubaHuyan.vue?vue&type=script&lang=js&"
export * from "./PopularizeDubaHuyan.vue?vue&type=script&lang=js&"
import style0 from "./PopularizeDubaHuyan.vue?vue&type=style&index=0&id=647dfd79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647dfd79",
  null
  
)

export default component.exports